export default __webpack_public_path__ + "static/media/about_us_video.66a40f30.mp4";